import { Box } from "@mui/material";
import { type TimeSlot } from "@src/appV2/redesign/Shift/types";

import { QualificationPicker } from "./QualificationPicker";
import { ShiftDateAndSlotPicker } from "./ShiftDateAndSlotPicker";

interface ShiftDatePickerHeaderProps {
  availableQualifications: string[];
  qualification: string;
  selectedDate: Date;
  selectedTimeSlot: TimeSlot;
  timezone: string;
  workplaceId: string;
  onDateChange: (date: Date) => void;
  onQualificationChange: (qualification: string) => void;
  onTimeSlotChange: (slot: TimeSlot) => void;
}

/**
 * Header for the chat invite dialog showing the qualification (when multiple
 * match) and the date/time-slot pickers.
 */
export function ShiftDatePickerHeader(props: ShiftDatePickerHeaderProps) {
  const {
    availableQualifications,
    qualification,
    selectedDate,
    selectedTimeSlot,
    timezone,
    workplaceId,
    onDateChange,
    onQualificationChange,
    onTimeSlotChange,
  } = props;

  const showQualificationPicker = availableQualifications.length > 1;

  return (
    <Box
      sx={(theme) => ({
        padding: theme.spacing(5),
        borderBottom: `1px solid ${theme.palette.border?.base}`,
        display: "flex",
        flexDirection: "column",
        gap: 4,
      })}
    >
      {showQualificationPicker && (
        <QualificationPicker
          qualifications={availableQualifications}
          selectedQualification={qualification}
          onChange={onQualificationChange}
        />
      )}
      <ShiftDateAndSlotPicker
        qualification={qualification}
        selectedDate={selectedDate}
        selectedTimeSlot={selectedTimeSlot}
        timezone={timezone}
        workplaceId={workplaceId}
        onDateChange={onDateChange}
        onTimeSlotChange={onTimeSlotChange}
      />
    </Box>
  );
}
